import { Item, ItemText } from '@radix-ui/react-select';
import { cva, VariantProps } from 'class-variance-authority';
import { ComponentPropsWithoutRef, ReactNode } from 'react';
import './select.scss';

const selectItemVariants = cva('select__item', {
    variants: {
        variant: {
            default: null,
            rounded: 'select__item--rounded',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

type Props = ComponentPropsWithoutRef<typeof Item> &
    VariantProps<typeof selectItemVariants> & {
        right?: ReactNode;
    };
export const SelectItem = ({ className, children, variant, right, ...props }: Props) => {
    return (
        <div className={selectItemVariants({ variant, className })}>
            <Item data-testid="select-item" {...props}>
                <ItemText>{children}</ItemText>
            </Item>
            {right}
        </div>
    );
};
